import { render } from "./productDetailSingleSubOption.vue?vue&type=template&id=134357e4"
import script from "./productDetailSingleSubOption.vue?vue&type=script&lang=js"
export * from "./productDetailSingleSubOption.vue?vue&type=script&lang=js"

import "./productDetailSingleSubOption.vue?vue&type=style&index=0&id=134357e4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__